var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"sr-label",attrs:{"label":"","color":_vm.backgroundColor,"text-color":_vm.color}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.hasAction)?_c('SrIcon',{staticClass:"ml-3 clickable",attrs:{"size":"xxs","icon":_vm.actionIcon},on:{"click":function($event){return _vm.$emit('action')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }